import React, { useContext } from 'react';
import {
    Container,
    SquareTextHolder,
    Square,
    Text,
    StripedSquare
} from './SizeSelectionLegend.styles';
import { Context as TranslationContext } from '../../contexts/TranslationContext';

interface SizeSelectionLegendProps {
    designViewMode: boolean;
    heatRecoveryType: string;
    passivhausCompatible: boolean;
}

const SizeSelectionLegend: React.FC<SizeSelectionLegendProps> = ({
    designViewMode
}) => {
    const hidePassivHausColor = true; //Force hide in Light as it is not supported.
    const { l } = useContext(TranslationContext);
    return (
        <Container
            $designviewmode={designViewMode}
            $hidepassivhauscolor={hidePassivHausColor}
        >
            <SquareTextHolder>
                <Square $designviewmode={designViewMode} color="#cbe7c0" />
                <Text>{l('unitTypeSelector.minMaxAirflow')}</Text>
            </SquareTextHolder>
            <SquareTextHolder>
                <StripedSquare
                    $designviewmode={designViewMode}
                    color="#cbe7c0"
                />
                <Text>{l('unitTypeSelector.ExtractMinMaxAirflow')}</Text>
            </SquareTextHolder>
            {!designViewMode && (
                <SquareTextHolder>
                    <Square $designviewmode={designViewMode} color="#d7d7d7" />
                    <Text>
                        {l('unitTypeSelector.notCompatibleWithSettings')}
                    </Text>
                </SquareTextHolder>
            )}
            {!hidePassivHausColor && (
                <SquareTextHolder>
                    <Square $designviewmode={designViewMode} color="#e8d663" />
                    {!designViewMode && (
                        <Text>
                            {l('unitTypeSelector.passivHausMinMaxAirflow')}
                        </Text>
                    )}
                    {designViewMode && (
                        <Text>
                            {l('unitTypeSelector.passivHausMinMaxAirflowShort')}
                        </Text>
                    )}
                </SquareTextHolder>
            )}
        </Container>
    );
};

export default SizeSelectionLegend;
